<template>
  <div class="app"><router-view /></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.app {
  display: grid;
  align-content: center;
  min-height: 100vh;
  background: hsl(185, 41%, 84%);
}
</style>
